import Vue from "vue";
import axios from "@/axios";
import { createApp } from 'vue';
import App from '../App.vue';
const api = {
    home:{
        homeApi: (params) => axios.get("/api/index/info", params),
        brandListApi: (params) => axios.get("/api/brand/list", params),
        brandGoodsListApi: (params) => axios.get("/api/brand/goods/list", {params}),
        brandInfoApi: (params) => axios.get("/api/brand/info", {params}),
        productLineList: (params) => axios.get("/api/product/line/list", params),
        productLineInfo: (params) => axios.get("/api/product/line/info", {params}),
        productLineGoods: (params) => axios.get("/api/product/line/goods", {params}),
        promotionproductList : (params) => axios.get("/api/promotion/productList", {params}),
        promotionbrandList: (params) => axios.get("/api/promotion/brandList", {params}),
        productCate: (params) => axios.get("/api/product/cate", {params}),
        productCateSkuItem : (params) => axios.get("/api/item/product", {params}),
        indexHtml : (params) => axios.get("/api/index/html", {params}),
        pointbannerList : (params) => axios.get("/api/points/brand", {params}),
    },
    Login: {
        loginApi: (params) => axios.post("/api/user/login", params),
        registerApi: (params) => axios.post("/api/user/register", params),
        checkEmailApi: (params) => axios.post("/api/check/email", params),
        checkMobileApi: (params) => axios.post("/api/check/mobile", params),
        logoutApi: (params) => axios.post("/api/user/logout", params),
        getUserInfoApi: (params) => axios.get("/api/user/info", params),
        verifycodesendApi: (params) => axios.post("/api/user/verifycode/send", params),
        verifycodesubmitApi: (params) => axios.put("/api/user/verifycode/submit", params),
        checkCommunicateApi: (params) => axios.post("/api/check/communicate", params),
        agreeTermsApi: (params) => axios.post("/api/user/terms/agree", params),
    },
    myOrder:{
        updatePassword:(params) => axios.put("/api/user/editPassword",params),
        centerUserInfo:(params) => axios.get("/api/personal/info",params),
        updateUserInfo:(params) => axios.put("/api/personal/edit",params),
        orderConfirm:(params) => axios.get("/api/order/confirm",params),
        invoiceUpdate:(params) => axios.put("/api/invoice/update",params),
        orderCreate:(params) => axios.post("/api/order/create",params),
        addressList:(params) => axios.get("/api/address/list",{params}),
        getRegion:(params) => axios.get("/api/region/get",{params}),
        addressAdd:(params) => axios.post("/api/address/add",params),
        addressDel:(params) => axios.delete("/api/address/del",{params}),
        setDefault:(params) => axios.put("/api/address/default",params),
        addressInfo:(params) => axios.get("/api/address/info",{params}),
        addressUpdate:(params) => axios.put("/api/address/update",params),
        personalOrderList:(params) => axios.post("/api/personal/order/list",params),
        personalAnotherOrder:(params) => axios.post("/api/personal/another/order",params),
        personalorderDetail:(params) => axios.post("/api/personal/order/detail",params),
        personalCancelOrder:(params) => axios.put("/api/personal/cancel/order",params),
        orderStatement:(params) => axios.get("/api/order/statement",{params}),
        orderPrice:(params) => axios.post("/api/order/price",params),
        orderPay:(params) => axios.post("/api/order/pay",params),
        orderPayed:(params) => axios.get("/api/order/payed",{params}),
        printOrder:(params) => axios.get("/api/soc/download",{params}),
        // 支付管理开始
        prepayPort:(params) => axios.get("/api/personal/prepay",{params}),
        couponPort:(params) => axios.get("/api/personal/coupon",{params}),
        // 支付管理结束
    },
    search:{
        searchDataApi:(params) => axios.post("/api/search/keyword2",params),
        coaDownload:(params) => axios.get("/api/pdf/coa",{params}),
        apipdfmsds:(params) => axios.get("/api/pdf/msds",{params}),
    },
    shopCar:{
        addCartApi:(params) => axios.post("/api/cart/add",params),
        cartListApi:(params) => axios.get("/api/cart/list",params),
        cartCheck :(params) => axios.put("/api/cart/check",params),
        cartClear :(params) => axios.delete("/api/cart/clear",params),
        cartReduce:(params) => axios.delete("/api/cart/reduce",{params}),
        editCart:(params) => axios.put("/api/cart/edit",params),
        cartaddFast:(params) => axios.post("/api/cart/addFast",params),
        cartImport:(params) => axios.post("/api/cart/import",params),
    },
    goods:{
        productDetailApi:(params) => axios.get("/api/product/detail",{params}),
        homeclassifyApi:(params) => axios.get("/api/index/header",{params}),
        hcproductDetail:(params) => axios.get("/api/product/detail",{params}),
        itemDetailApi:(params) => axios.get("/api/item/detail",{params}),
        productStockApi:(params) => axios.get("/api/product/stock",{params}),
        orderexpress:(params) => axios.get("/api/personal/order/express",{params}),
    },
    jfGoods:{
        pointsList:(params) => axios.get("/api/points/list",{params}),
        pointsOptionsList:(params) => axios.get("/api/points/options/list",{params}),
        pointsread:(params) => axios.get("/api/points/read",{params}),
        pointsexchange:(params) => axios.post("/api/points/exchange",params),
        pointsOrderList:(params) => axios.get("/api/points/order/list",{params}),
        pointsOrderDetail:(params) => axios.get("/api/points/order/read",{params}),
        pointsCancel:(params) => axios.post("/api/points/cancel",params),
    },
    user:{
       largePackage:(params) => axios.post("/api/largePackage/inquiry/add",params), 
    }
}
const app = createApp(App);
app.config.globalProperties.$api = api;
export default api
